import { USER_WORKER_URL } from '../../config.js';
import { fetchCache } from '../../utils/fetchCache.js';
import { getAuthToken } from '../videoScheduleApi.js';

const JOB_KIND = {
  sprite_generation: 'sprite',
  video_generation: 'video',
};

export const pollCreateVideoJobs = ({
  getActiveMode,
  refreshImageGrid,
  refreshVideoGrid,
  shouldSuppressToast,
  onToast,
}) => {
  let lastCheck = Date.now();

  const markRead = async (token, notificationId) => {
    if (!notificationId) return;
    try {
      await fetchCache.fetchJSON(`${USER_WORKER_URL}/notifications/read`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: { notification_id: notificationId },
      });
    } catch (err) {
      console.warn('[CreateVideo] Failed to mark notification as read:', err);
    }
  };

  const poll = async () => {
    if (document.hidden) return;
    try {
      const token = await getAuthToken();
      if (!token) return;

      const data = await fetchCache.fetchJSON(`${USER_WORKER_URL}/notifications`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: { limit: 30, unread_only: false },
      });

      const notifications = data.notifications || [];
      let newestSeen = lastCheck;
      const mode = getActiveMode();
      let refreshImage = false;
      let refreshVideo = false;
      const markIds = [];
      let toastImage = false;
      let toastVideo = false;

      for (const notification of notifications) {
        const createdAtMs = new Date(notification.created_at).getTime();
        if (!Number.isNaN(createdAtMs)) newestSeen = Math.max(newestSeen, createdAtMs);
        if (createdAtMs <= lastCheck) continue;

        const kind = JOB_KIND[notification.type];
        if (!kind) continue;

        if (kind === 'sprite') {
          if (mode === 'sprite-text') refreshImage = true;
          else refreshVideo = true;
          toastImage = true;
        } else if (kind === 'video' && mode === 'video-text') {
          refreshVideo = true;
          toastVideo = true;
        }

        markIds.push(notification.notification_id || notification.id);
      }

      if (refreshImage) await refreshImageGrid?.();
      if (refreshVideo) await refreshVideoGrid?.();
      if (!shouldSuppressToast?.()) {
        if (toastImage) onToast?.('Your image is ready!', 'success');
        if (toastVideo) onToast?.('Your video is ready!', 'success');
      }
      await Promise.all(markIds.map((id) => markRead(token, id)));

      lastCheck = newestSeen;
    } catch (error) {
      console.warn('[CreateVideo] Error checking for completion notifications:', error);
    }
  };

  setInterval(poll, 10000);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) setTimeout(poll, 1000);
  });
};
